import React, {Component} from 'react';
import InterviewInfo from './subPages/interviewInfo';
import QueVideo from './subPages/queVideo';
import Summary from './subPages/summary';
import Placeholder from '../../analysisReport/common/placeholder';
import {ajax, unparam, chatColor} from '../../../utils/common';
import './index.less';

// 国际化
import i18nZh_cn from 'utils/zh_cn';
import i18nEn_us from 'utils/en_us';

class Index extends Component {
  state = {
    themeColor: "#00C3D5",	//页面主色
    i18n: i18nZh_cn,
    userInfo: {},
    paperInfo: {},
    summary: {},
    result: {},
    accountId: "",
    finishStatus: -1,
    videoUrl: "",
    videoReportUrl: ""
  }

  //获取试卷
  getPaper = (accountId, showVideo = false, timestamp, sign) => {
    ajax({
      url: "/rept/paper/getPaperById",
      data: {
        accountId,
        timestamp,
        sign,
      }
    }).then(res => {
      //试卷列表
      const interviewQuesVOs = res.data.interviewQuesVOs;
      this.setState({
        paperInfo: res.data
      }, () => {
        //获取第一个视频的url
        showVideo && this.handleClick(interviewQuesVOs[0].questionId);
      });
    })
  }

  handleClick = (qId, callback) => {
    const { accountId, paperInfo, userInfo } = this.state;
    //账号删除的情况下无法查看视频
    if(userInfo.status === 5) return false;
    //获取视频的url
    ajax({
      url: "/api/file/viewVideo",
      data: {
        accountId: accountId,
        paperId: paperInfo.paperId,
        questionId: qId
      }
    }).then(res => {
      this.setState({
        videoUrl: "/oivi/api/file/review/"+ res.data.videoFileUrl
      });
      typeof callback === 'function' && callback(res.data);
    })
  }

  getAccountById = (params = {}, options = {}) => {
    ajax({
      url: "/rept/account/getAccountById",
      data: params
    }).then(account => {
      options.success && options.success(account);
    }).catch(err => {
      console.log("fail: ", err);
      options.error && options.error(err);
    });
  }

  //获取视频AI分析汇总数据
  getSummary = (accountId, i18n) => {
    ajax({
      url: "/api/file/videoReport/summary",
      data: {
        accountId: accountId
      }
    }).then(res => {
      const data = res.data || {};
      for(let i in data.emos) {
        data.emos[i].emotion = i18n.report.emotion[i];
        data.emos[i].strengthDesc = i18n.report[data.emos[i].strength === 0 ? 'weak' : 'strong'];
      }
      this.setState({
        summary: data
      });
    }).catch(err => {
      console.log("summary fail: ", err)
    });
  }

  //获取视频AI分析汇每秒数据
  getResult = (accountId) => {
    ajax({
      url: "/api/file/videoReport/result",
      data: {
        accountId: accountId
      }
    }).then(res => {
      this.setState({
        videoReportUrl: "/oivi/api/file/videoReport/video?accountId=" + accountId,
        result: res.data
      });
    }).catch(err => {
      console.log("result fail: ", err)
    });
  }

  updateUserInfo = () => {
    //获取页面参数
    const queryString = unparam(location.search);
    this.getAccountById({
      accountId: this.state.accountId,
      timestamp: queryString.timestamp,
      sign: queryString.sign,
      isAccess: 1
    }, {
      success: account => {
        this.setState({
          userInfo: account.data
        });
      }
    });
  }

  componentDidMount() {
    //获取页面参数
    const queryString = unparam(location.search);
    // 国际化
    const lang = queryString.lang ? queryString.lang.toLocaleLowerCase() : "zh_cn";
    const i18n = lang === "en_us" ? i18nEn_us : i18nZh_cn;
    this.setState({
      i18n
    });
    //获取页面主色
    let themeColor = queryString.themeColor ? (queryString.themeColor.indexOf("#") >= 0 ? queryString.themeColor : ("#" + queryString.themeColor)) : this.state.themeColor;
    if(!Object.keys(chatColor).includes(themeColor)) {
      themeColor = this.state.themeColor;
    }
    // 获取账号信息
    this.getAccountById({
      accountId: queryString.accountId,
      timestamp: queryString.timestamp,
      sign: queryString.sign,
      isAccess: 1
    }, {
      success: account => {
        document.title = account.data.userName + "-" + i18n.index.subtitle2;
        this.setState({
          themeColor: themeColor,
          finishStatus: account.data.status,
          accountId: queryString.accountId,
          userInfo: account.data
        });
        this.getPaper(queryString.accountId, true, queryString.timestamp, queryString.sign);
        if(account.data.aiVaild === 1 || account.data.reportStatus !== 0) {
          //获取视频AI分析汇每秒数据
          this.getResult(queryString.accountId);
          //获取视频AI分析汇总数据
          this.getSummary(queryString.accountId, i18n);
        }
        if(account.data.reportStatus != 2 || account.data.reportStatus != 3) {
          // 2: 报告已生成，3: 报告生成失败
          /* 定时1分钟去获取报告状态 */
          const timer = setInterval(() => {
            this.getAccountById({
              accountId: queryString.accountId,
              timestamp: queryString.timestamp,
              sign: queryString.sign,
              isAccess: 1
            }, {
              success: res => {
                const userInfo = res.data;
                if(userInfo.reportStatus == 2 || userInfo.reportStatus == 3){
                  this.setState({ userInfo });
                  clearInterval(timer);
                }
              }
            });
          }, 60000);
        }
      },
      error: err => {
        if(err.data.status === 5){
          this.setState({
            themeColor: themeColor,
            finishStatus: 1,
            accountId: queryString.accountId,
            userInfo: err.data
          });
        } else {
          this.setState({
            themeColor: themeColor,
            finishStatus: 0,
            accountId: queryString.accountId,
            userInfo: err.data
          });
        }
        this.getPaper(queryString.accountId, false, queryString.timestamp, queryString.sign);
      }
    });
  }

  render() {
    const { i18n, userInfo, paperInfo, themeColor, videoUrl, videoReportUrl, summary, result } = this.state;
    const { isValid } = this.props;
    return (
      <div className="video-app-wrap">
        <div className="video-main-wrap" style={{ minWidth: "1000px" }}>
          <div className="other-paper-wrap">
            {
              isValid ?
              <React.Fragment>
                <InterviewInfo reportStatus={userInfo.reportStatus} userInfo={userInfo}
                              paperInfo={paperInfo} i18n={i18n} themeColor={themeColor} />
                {userInfo.reportStatus === 2 ?
                  <Summary updateUserInfo={this.updateUserInfo} useful={userInfo.useful} result={result} handleClick={this.handleClick} paperInfo={paperInfo}
                          videoUrl={videoUrl} videoReportUrl={videoReportUrl} summary={summary} themeColor={themeColor} i18n={i18n} />
                  : <QueVideo userInfo={userInfo} handleClick={this.handleClick}
                              paperInfo={paperInfo} videoUrl={videoUrl} i18n={i18n} themeColor={themeColor} />}
              </React.Fragment> :
              <Placeholder />
            }
          </div>
        </div>
      </div>
    );
  }
}

export default Index;
